import { Grid, Paper } from "@material-ui/core";
import React, { Children } from "react";
import { useStyles } from "../Utils/Styles";
import BadgeLink from "./BadgeLink";
import Title from "./Title";

/**
 * Shared module landing layout. Pass dialog launchers as `actions`, translated
 * BadgeLink props as `navigation`, search controls as `filters`, and data as
 * children. Controlled dialogs can be mounted separately through `dialogs`.
 *
 * <ModuleLandingPage
 *   title={t("module.header")}
 *   actions={<Button onClick={openDialog}>{t("add")}</Button>}
 *   navigation={[{ href: "/cpanel/example", title: t("example"), icon: Icon }]}
 *   filters={<Grid item xs={12}><TextField ... /></Grid>}
 *   dialogs={<EditDialog ... />}
 * >
 *   <SortableTable ... />
 * </ModuleLandingPage>
 */
export default function ModuleLandingPage({
  title,
  actions,
  navigation = [],
  filters,
  dialogs,
  children,
}) {
  const classes = useStyles();
  const actionItems = Children.toArray(actions);

  return (
    <>
      {dialogs}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            {title ? <Title>{title}</Title> : null}
            {actionItems.length ? (
              <Grid container spacing={2} alignItems="center">
                {actionItems.map((action, index) => (
                  <Grid item key={action.key || index}>
                    {action}
                  </Grid>
                ))}
              </Grid>
            ) : null}
            {navigation.length ? (
              <Grid
                container
                spacing={2}
                style={actionItems.length ? { marginTop: 8 } : undefined}
              >
                {navigation.map(({ path, href, ...item }) => (
                  <BadgeLink key={href || path} href={href || path} {...item} />
                ))}
              </Grid>
            ) : null}
          </Paper>
        </Grid>
        {filters ? (
          <Grid item xs={12}>
            <Paper className={classes.paper} style={{ overflow: "hidden" }}>
              <Grid container spacing={3} alignItems="center">
                {filters}
              </Grid>
            </Paper>
          </Grid>
        ) : null}
        <Grid item xs={12}>
          <Paper className={classes.paper}>{children}</Paper>
        </Grid>
      </Grid>
    </>
  );
}
